import { createBrowserHistory } from 'history';
import axios from 'axios';
import queryString from 'query-string';
import Cookies from 'universal-cookie';
import { showToast, serverError, serverUnderMaintenance } from '../actions';
import { store } from '../index';
import constants from '../shared/constants/environmentConfig';
import { getHomeDomain, isMobileDevice, getAccountsDomain } from './Utils';

const history = createBrowserHistory({
  forceRefresh: true,
});

const cookies = new Cookies();
const Constants = constants;

const getToken = () => {
  const token = cookies.get('token');
  if (token) {
    return `bearer ${cookies.get('token')}`;
  }
  return '';
};

export const getUser = () => {
  const user = cookies.get('user');
  return user || {};
};

export const expiry = () => {
  history.push('/payment');
};

const redirectToInstituteTest = (testId, message) => {
  store.dispatch(showToast(message));
  history.push(`/test/${testId}`);
};

const logout = () => {
  Object.keys(cookies.getAll()).forEach((cookieName) => {
    cookies.remove(cookieName,
      { secure: Constants().cookie.secure, domain: Constants().cookie.domainRegex });
    cookies.remove(cookieName, { path: '/', secure: Constants().cookie.secure });
  });
  const isServer = typeof window === 'undefined';
  if (!isServer) {
    window.location.replace(`${getAccountsDomain()}/logout`);
  }
};

const notifyServerMaintenance = () => {
  store.dispatch(serverUnderMaintenance());
};

const Api = (options) => {
  const onSuccess = (response) => {
    const { REACT_APP_ENV } = process.env;
    if (REACT_APP_ENV !== 'production') {
      console.log('Request Successful!', 'response');
    }
    if (response.status === 307) {
      redirectToInstituteTest(response.test_id, response.message);
    }
    if (response.status === 410) {
      expiry();
    }
    if (response.status === 401) {
      logout();
    }
    if (response.status === 406) {
      if (response.data.redirect_domain) {
        window.location.href = response.data.redirect_domain;
      } else {
        window.location.href = getHomeDomain();
      }
    }
    return response.data;
  };

  const onError = (error) => {
    if (error.response && error.response.status === 307) {
      redirectToInstituteTest(error.response.data.test_id, error.response.data.message);
      return false;
    }
    if (error.response && error.response.status === 503) {
      notifyServerMaintenance();
    }
    if (error.response && error.response.status === 401) {
      logout();
    }
    if (error.response && error.response.status === 406) {
      if (error.response.data && error.response.data.redirect_domain) {
        window.location.href = error.response.data.redirect_domain;
      } else {
        window.location.href = getHomeDomain();
      }
    }

    if (error.response && error.response.status === 410) {
      expiry();
      return false;
    }
    const { REACT_APP_ENV } = process.env;
    if (REACT_APP_ENV !== 'production') {
      console.log('Request Failed:', error);

      if (error.response) {
        // Request was made but server responded with something
        // other than 2xx
        console.log('Status:', error.response.status);
        console.log('Data:', error.response.data);
        console.log('Headers:', error.response.headers);
      } else {
        // Something else happened while setting up the request
        // triggered the error
        console.log('Error Message:', error.message);
      }
    }
    store.dispatch(serverError());
    return error.response || error.message;
  };

  if (options.method === 'post') {
    if (options.attachment) {
      const config = { headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress: options.onUploadProgress };
      const formData = new FormData();
      const attachmentLength = options.attachment.length ? options.attachment.length : 1;
      if (attachmentLength === 1 && (!options.attachment.length || options.type !== 'spreadsheet')) {
        formData.append(options.type, options.attachment);
      } else {
        options.attachment.forEach((file, index) => {
          formData.append(`${options.type}_${index + 1}`, file);
        });
      }
      if (options.data) {
        Object.keys(options.data).forEach((key) => {
          formData.set(key, options.data[key]);
        });
      }
      formData.set(`${options.type}_length`, attachmentLength);
      formData.set('token', getToken());
      formData.set('insightsAppVersionCode', constants().insightsAppVersionCode);
      return axios.post(`${constants().api.url}${options.url}`,
        formData,
        config).then(onSuccess)
        .catch(onError);
    }
    let data = {};
    return axios({
      method: options.method,
      url: `${constants().api.url}${options.url}`,
      data: options.data,
      transformRequest: [function query(value) {
        data = value || {};
        data.token = getToken();
        data.insightsAppVersionCode = constants().insightsAppVersionCode;
        data.isMobileBrowser = isMobileDevice();
        return queryString.stringify(data);
      }],
    })
      .then(onSuccess)
      .catch(onError);
  }
  let url = `${constants().api.url}${options.url}`;

  if (options.golangEndpoint === true) {
    url = `${constants().golangEndpoint}${options.url}`;
  }
  if (options.url.includes('?')) {
    url += `&token=${getToken()}&insightsAppVersionCode=${constants().insightsAppVersionCode}`;
  } else {
    url += `?token=${getToken()}&insightsAppVersionCode=${constants().insightsAppVersionCode}`;
  }

  return axios({
    method: options.method,
    url,
  })
    .then(onSuccess)
    .catch(onError);
};

export default Api;
